<template>
  <div class="device-detail-sheet">
    <div class="box" style="padding-bottom: 0px; padding-top: 8px">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- <el-form-item style="margin:0"> -->
          <el-radio-group v-model="formSearch.sheetType">
            <el-radio-button v-for="(item, index) in sheetType" :key="index" :label="item.label">{{ item.value }}</el-radio-button>
          </el-radio-group>
          <!-- </el-form-item> -->
          <div class="current-day-description" style="float: right; margin: 0" v-if="formSearch.sheetType === '1'">
            <a v-if="lastUpdateTime">
              {{ $t('dms_device_detail_sheet.zhgxsj') }}
              {{ momentAmPm($momentLocal(lastUpdateTime)) }}
            </a>
            <span @click="onRefreshDay">{{ $t('dms_device_detail_sheet.shua_xin') }}</span>
          </div>
          <el-form-item style="float: right; margin: 0" v-show="formSearch.sheetType === '2'">
            <!-- 日报表 -->
            <custom-date-picker
              :init-value="initReportStartTime"
              v-model="startTime"
              type="date"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="beforeToday2016"
              @change="startTimeChange"
              style="width: 160px"
              :clearable="false"
              prefix-icon="icon icon-calendar"
            ></custom-date-picker>
          </el-form-item>
          <!-- <el-form-item > -->
          <el-radio-group v-model="reportType" style="float: right; margin-right: 0px" v-if="formSearch.sheetType === '3'">
            <el-radio-button v-for="(item, index) in propertyMap.dms_summary_report_type" :key="index" :label="item.value">{{ item.name }}</el-radio-button>
          </el-radio-group>
          <!-- </el-form-item> -->
          <el-form-item style="float: right" v-if="formSearch.sheetType === '3'">
            <!-- 历史报表 -->
            <!-- 年 -->
            <year-picker v-show="reportType === '1'" v-model="reportYearTime"></year-picker>
            <!-- 季度 -->
            <season-picker v-show="reportType === '2'" v-model="reportSeasonTime" ref="jidupicker"></season-picker>
            <!-- 月 -->
            <custom-date-picker
              v-show="reportType === '3'"
              v-model="reportMonthTime"
              type="monthrange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              align="right"
              :placeholder="$t('dms_device_detail_sheet.xuan_ze_yue')"
              :picker-options="pickerOptionsIntervalThreeYears"
              prefix-icon="icon icon-calendar"
              :clearable="false"
              style="width: 240px"
            ></custom-date-picker>
            <!--周 -->
            <week-picker v-show="reportType === '4'" v-model="reportWeekTime"></week-picker>
            <!-- 日 -->
            <custom-date-picker
              v-show="reportType === '5'"
              v-model="reportDayTime"
              :init-value="initReportDayTime"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="beforeToday2016"
              :clearable="false"
              style="width: 260px"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item style="float: right" v-show="formSearch.sheetType === '4' && `${productClass}` === '1'">
            <!--路径报表 -->
            <custom-date-picker
              v-model="usageTimer"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :init-value="initUsageTimerValue"
              :picker-options="beforeToday2016"
              :clearable="false"
              style="width: 260px"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item style="float: right" v-show="formSearch.sheetType === '4' && `${productClass}` === '2'">
            <!--路径报表 -->
            <custom-date-picker
              v-model="pathTimer"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :init-value="initPathTimerValue"
              :picker-options="beforeToday2016"
              :clearable="false"
              style="width: 260px"
            ></custom-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <device-detail-sheet-currentDay
      ref="currentDay"
      v-if="formSearch.sheetType === '1'"
      :deviceInfo="deviceInfo"
      :isCharging="isCharging"
      :isManual="isManual"
      :isAutonomous="isAutonomous"
      :isTraining="isTraining"
      :isBoot="isBoot"
      v-model="lastUpdateTime"
    ></device-detail-sheet-currentDay>
    <!--
      传统机  -1
      机器人  -2
    -->
    <device-detail-sheet-day-ice
      v-if="formSearch.sheetType === '2' && `${productClass}` === '1'"
      :deviceInfo="deviceInfo"
      :isCharging="isCharging"
      :isManual="isManual"
      :isAutonomous="isAutonomous"
      :isTraining="isTraining"
      :isBoot="isBoot"
      :startTime="startTime"
      :endTime="endTime"
    ></device-detail-sheet-day-ice>
    <device-detail-sheet-day
      v-if="formSearch.sheetType === '2' && `${productClass}` === '2'"
      :deviceInfo="deviceInfo"
      :isCharging="isCharging"
      :isManual="isManual"
      :isAutonomous="isAutonomous"
      :isTraining="isTraining"
      :isBoot="isBoot"
      :startTime="startTime"
      :endTime="endTime"
    ></device-detail-sheet-day>
    <!-- 历史详情 -->
    <device-detail-sheet-history
      v-if="formSearch.sheetType === '3'"
      :deviceInfo="deviceInfo"
      :reportType="reportType"
      :reportYearTime="reportYearTime"
      :reportSeasonTime="reportSeasonTime"
      :reportMonthTime="reportMonthTime"
      :reportWeekTime="reportWeekTime"
      :reportDayTime="reportDayTime"
      :isCharging="isCharging"
      :isManual="isManual"
      :isAutonomous="isAutonomous"
      :isTraining="isTraining"
      :isBoot="isBoot"
    ></device-detail-sheet-history>
    <!-- ice使用记录 -->
    <device-detail-usage-details
      v-if="formSearch.sheetType === '4' && `${productClass}` === '1'"
      :deviceInfo="deviceInfo"
      :reportType="reportType"
      :usageTimer="usageTimer"
      :isCharging="isCharging"
      :isManual="isManual"
      :isAutonomous="isAutonomous"
      :isTraining="isTraining"
      :isBoot="isBoot"
    ></device-detail-usage-details>
    <!-- 路径 -->
    <device-detail-path-history
      v-if="formSearch.sheetType === '4' && `${productClass}` === '2'"
      :deviceInfo="deviceInfo"
      :reportType="reportType"
      :pathTimer="pathTimer"
      :isCharging="isCharging"
      :isManual="isManual"
      :isAutonomous="isAutonomous"
      :isTraining="isTraining"
      :isBoot="isBoot"
    ></device-detail-path-history>
  </div>
</template>

<script>
import moment from 'moment';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';
import deviceDetailSheetCurrentDay from './device_detail_sheet_currentDay.vue';
import deviceDetailSheetDay from './device_detail_sheet_day.vue';
import deviceDetailSheetDayIce from './device_detail_sheet_day_ice.vue';
import deviceDetailSheetHistory from './device_detail_sheet_history.vue';
import deviceDetailPathHistory from './device_detail_path_history.vue';
import deviceDetailUsageDetails from './device_detail_usage_details.vue';

export default {
  props: {
    deviceInfo: [Object, Array],
  },
  components: {
    deviceDetailSheetCurrentDay,
    deviceDetailSheetDay,
    deviceDetailSheetDayIce,
    // deviceDetailSheetHistoryIce,
    deviceDetailSheetHistory,
    deviceDetailPathHistory,
    seasonPicker,
    yearPicker,
    weekPicker,
    deviceDetailUsageDetails,
  },
  data() {
    return {
      formSearch: {
        sheetType: '1', // 1:'今日报表' 2:'日报表' 3:'历史报表'  4：'路径历史'
        year: '',
        timeType: '',
      },
      isLoading: false,
      // 今日报表
      cuttrentTime: moment().format('YYYY-MM-DD HH:mm'),
      lastUpdateTime: '',
      // 日报表
      // startTime: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      initReportStartTime: moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00'),
      startTime: '',
      endTime: this.$momentWorld(moment().format('YYYY-MM-DD 00:00:00')),
      // initStartTime: '',
      // 路径报表
      initPathTimerValue: [moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
      pathTimer: [],
      initUsageTimerValue: [moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
      usageTimer: [],
      // 历史报表
      // reportYearTime: `${moment().year()}`,
      reportYearTime: [`${moment().add(-11, 'y').year()}`, `${moment().year()}`],
      // reportSeasonTime: `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth() + 1)}`,
      reportSeasonTime: [
        new Date().getMonth() < 10 ? `${new Date().getFullYear() - 2}-${this.getSeason(new Date().getMonth() - 9)}` : `${new Date().getFullYear() - 2}-01`,
        `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`,
      ],
      // reportMonthTime: `${moment().format('YYYY-MM')}`,
      reportMonthTime: [`${moment().add(-11, 'month').format('YYYY-MM')}`, `${moment().add('month').format('YYYY-MM')}`],
      // 周是日期类型 用的时候需要moment转YYYY-MM-DD
      // reportWeekTime: `${new Date()}`,
      // reportWeekTime: `${new Date(moment().week(moment().week() - 1).startOf('week').valueOf())}`,
      // reportWeekTime: [`${new Date(moment().week(moment().week() - 1).startOf('week').valueOf())}`, `${new Date(moment().week(moment().week()).startOf('week').valueOf())}`],
      //  .endOf('week')
      reportWeekTime: [this.$momentElLocal(moment().week(moment().week() - 11)), this.$momentElLocal(moment().week(moment().week()))],
      initReportDayTime: [moment(this.$getLocalTime()).subtract(30, 'days').startOf('day').format('YYYY-MM-DD 00:00:00'), moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59')],
      reportDayTime: [],
      reportType: '3',
      msgStatistics: {},

      // 新增/编辑
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},

      // 设备类型
    };
  },
  computed: {
    sheetType() {
      let ret = [];

      // this.sheetType.pop();
      ret = [
        {
          label: '1',
          value: this.$t('dms_device_detail_sheet.jin_ri_bao_biao'),
        },
        {
          label: '2',
          value: this.$t('dms_device_detail_sheet.ri_bao_biao'),
        },
        {
          label: '3',
          value: this.$t('dms_device_detail_sheet.li_shi_bao_biao'),
        },
        {
          label: '4',
          value: this.$t('dms_device_detail_sheet.shi_yong_li_shi'),
        },
      ];

      return ret;
    },
    // 充电
    isCharging() {
      return this.deviceInfo.supportFunc.includes('charging');
    },
    // 手工
    isManual() {
      return this.deviceInfo.supportFunc.includes('manual');
    },
    // 自动
    isAutonomous() {
      return this.deviceInfo.supportFunc.includes('autonomous');
    },
    // 教学
    isTraining() {
      return this.deviceInfo.supportFunc.includes('training');
    },
    // 教学
    isBoot() {
      return this.deviceInfo.supportFunc.includes('boot');
    },
    productClass() {
      // 传统机  -1
      // 机器人  -2
      return this.deviceInfo.productClass || '';
    },
  },

  mounted() {
    this.getDictionary('dms_summary_report_type');
  },
  methods: {
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    startTimeChange(val) {
      // 本地时间转utc时间
      this.startTime = val;
      this.endTime = moment(val).add(1, 'd').format('YYYY-MM-DD 00:00:00');
    },
    // 刷新今日报表
    onRefreshDay() {
      this.$refs.currentDay.$emit('onRefresh'); // 刷新当天报表
    },
  },
};
</script>

<style lang="scss">
.device-detail-sheet {
  background-color: #e4ebf2;
  .box {
    // padding: 0 24px 24px;
    padding: 24px;
    background-color: #fff;
  }
  .current-day-description {
    background-color: #fff;
    height: 28px;
    font-size: 12px;
    color: rgba(108, 117, 125, 1);
    line-height: 28px;
    span {
      color: rgba(13, 154, 224, 1);
      margin-left: 10px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  // 时间框
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    .el-input__inner {
      padding: 0 12px 0 32px;
      font-size: 14px;
    }
    .el-input__prefix {
      left: 10px;
    }
    .icon-calendar {
      font-size: 14px;
      color: rgba(13, 154, 224, 1);
    }
  }
}
</style>
